// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantitativo-resultados-encontrados-list-view-usuarios {
    display: flex;
    align-items: center;
    height: 30px;
    margin-top: .3rem;
}

.quantidade-usuarios-encontradas {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: inherit;
    background-color: var(--fundo-input2);
    margin-right: .5rem;
    color: var(--azul-dixi);
    font-weight: bold;
    border-radius: 8px;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.05);
}

.texto-resultado-usuarios-encontradas {
    font-weight: bold;
    color: var(--cinza-label-input-padrao);
}

.container-list-view-usuario-nao-encontrado {
    display: flex;
    width: 100%;
    background-color: var(--branco-padrao);
    margin-top: .5rem;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: .5rem .8rem 1rem .8rem;
    height: 60vh;
    align-items: center;
    justify-content: center;
}

.nenhuma-usuario-encontrada-container {
    margin-bottom: 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--texto-cinza);
}

.nenhuma-usuario-encontrada-container svg {
    font-size: 6.5rem;
    margin-bottom: .2rem;
}

.referencia-cadastro-nova-usuario {
    font-weight: bold;
    margin-top: 1rem;
}

.referencia-cadastro-nova-usuario a {
    text-decoration: none;
    color: var(--azul-dixi);
}

.referencia-cadastro-nova-usuario a:hover {
    text-decoration: underline;
}

/* Estilos listview */
.header-list-view-usuario, .usuario-list-view-usuario {
    display: flex;
    width: 100%;
    height: 40px;
    border-radius: 8px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    justify-content: space-between;
    align-items: center;
    margin-bottom: .2rem;
}

.header-list-view-usuario{
    margin-bottom: .5rem;
}

.header-list-view-usuario {
    background-color: var(--fundo-input2);
}

.header-list-view-usuario span, .usuario-list-view-usuario span {
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--azul-dixi);
    border-right: 2px solid var(--branco-padrao);
    padding: .75rem;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
}

.header-list-view-usuario span:last-child, .usuario-list-view-usuario span:last-child {
    border-right: none;
}

.usuario-list-view-usuario span {
    font-weight: normal;
    border-right: 2px solid var(--cinza-fundo-input-padrao);
    color: var(--text-color2);
}

.header-list-view-usuario span.header-acao, .acao-usuario {
    flex: .3 1;
}

.usuario-list-view-usuario span.nome-usuario {
    justify-content: flex-start;
}

.header-list-view-usuario span.header-nome-usuario, .nome-usuario {
    flex: 2.5 1;
}

.header-list-view-usuario span.header-tipo-usuario, .tipo-do-usuario {
    flex: 1 1;
}

.header-list-view-usuario span.header-situacao-usuario, .situacao-cadastro-usuario {
    flex: 1 1;
}

.header-list-view-usuario span.header-cpf-usuario, .cpf-usuario {
    flex: 1 1;
}

.header-list-view-usuario span.header-email-usuario, .email-usuario {
    flex: 2 1;
}

.icone-editar-usuario {
    cursor: pointer;
    background-color: var(--fundo-input2);
    font-size: 1.5rem;
    width: 2rem;
    height: 2rem;
    padding: 0.1rem;
    border-radius: 6px;
    transition: all .15s;
}

.icone-editar-usuario:hover {
    color: var(--branco-padrao);
    background-color: var(--azul-dixi);
}`, "",{"version":3,"sources":["webpack://./src/components/ListViewUsuario/ListViewUsuario.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sCAAsC;IACtC,iBAAiB;IACjB,+CAA+C;IAC/C,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,4CAA4C;IAC5C,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,uDAAuD;IACvD,yBAAyB;AAC7B;;AAEA;IACI,UAAQ;AACZ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;AACtC","sourcesContent":[".quantitativo-resultados-encontrados-list-view-usuarios {\n    display: flex;\n    align-items: center;\n    height: 30px;\n    margin-top: .3rem;\n}\n\n.quantidade-usuarios-encontradas {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: inherit;\n    background-color: var(--fundo-input2);\n    margin-right: .5rem;\n    color: var(--azul-dixi);\n    font-weight: bold;\n    border-radius: 8px;\n    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.05);\n}\n\n.texto-resultado-usuarios-encontradas {\n    font-weight: bold;\n    color: var(--cinza-label-input-padrao);\n}\n\n.container-list-view-usuario-nao-encontrado {\n    display: flex;\n    width: 100%;\n    background-color: var(--branco-padrao);\n    margin-top: .5rem;\n    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.05);\n    border-radius: 8px;\n    padding: .5rem .8rem 1rem .8rem;\n    height: 60vh;\n    align-items: center;\n    justify-content: center;\n}\n\n.nenhuma-usuario-encontrada-container {\n    margin-bottom: 4rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: var(--texto-cinza);\n}\n\n.nenhuma-usuario-encontrada-container svg {\n    font-size: 6.5rem;\n    margin-bottom: .2rem;\n}\n\n.referencia-cadastro-nova-usuario {\n    font-weight: bold;\n    margin-top: 1rem;\n}\n\n.referencia-cadastro-nova-usuario a {\n    text-decoration: none;\n    color: var(--azul-dixi);\n}\n\n.referencia-cadastro-nova-usuario a:hover {\n    text-decoration: underline;\n}\n\n/* Estilos listview */\n.header-list-view-usuario, .usuario-list-view-usuario {\n    display: flex;\n    width: 100%;\n    height: 40px;\n    border-radius: 8px;\n    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: .2rem;\n}\n\n.header-list-view-usuario{\n    margin-bottom: .5rem;\n}\n\n.header-list-view-usuario {\n    background-color: var(--fundo-input2);\n}\n\n.header-list-view-usuario span, .usuario-list-view-usuario span {\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    color: var(--azul-dixi);\n    border-right: 2px solid var(--branco-padrao);\n    padding: .75rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: left;\n}\n\n.header-list-view-usuario span:last-child, .usuario-list-view-usuario span:last-child {\n    border-right: none;\n}\n\n.usuario-list-view-usuario span {\n    font-weight: normal;\n    border-right: 2px solid var(--cinza-fundo-input-padrao);\n    color: var(--text-color2);\n}\n\n.header-list-view-usuario span.header-acao, .acao-usuario {\n    flex: .3;\n}\n\n.usuario-list-view-usuario span.nome-usuario {\n    justify-content: flex-start;\n}\n\n.header-list-view-usuario span.header-nome-usuario, .nome-usuario {\n    flex: 2.5;\n}\n\n.header-list-view-usuario span.header-tipo-usuario, .tipo-do-usuario {\n    flex: 1;\n}\n\n.header-list-view-usuario span.header-situacao-usuario, .situacao-cadastro-usuario {\n    flex: 1;\n}\n\n.header-list-view-usuario span.header-cpf-usuario, .cpf-usuario {\n    flex: 1;\n}\n\n.header-list-view-usuario span.header-email-usuario, .email-usuario {\n    flex: 2;\n}\n\n.icone-editar-usuario {\n    cursor: pointer;\n    background-color: var(--fundo-input2);\n    font-size: 1.5rem;\n    width: 2rem;\n    height: 2rem;\n    padding: 0.1rem;\n    border-radius: 6px;\n    transition: all .15s;\n}\n\n.icone-editar-usuario:hover {\n    color: var(--branco-padrao);\n    background-color: var(--azul-dixi);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
